import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = { cells: {} };

const inputScreen = createSlice({
  name: 'inputScreen',
  initialState,
  reducers: {
    updateInputScreen: (state, action: PayloadAction<any>) => {
      state.cells = action.payload;
    },
  },
});

const { actions, reducer } = inputScreen;

export const { updateInputScreen } = actions;

export default reducer;
